import { EWalletId } from '@ankr.com/provider';
import { useCallback } from 'react';
import { ConnectArgs, useConnectMutation } from '../actions/connect';
import { useDisconnectMutation } from '../actions/disconnect';
import { useSwitchNetworkMutation } from '../actions/switchNetwork';
import { CONNECTION_CACHE_KEY } from '../const';
import { TChainId } from 'modules/api';

export interface IConnectionData {
  address?: string;
  chainId?: TChainId;
  isConnected: boolean;
  isLoading: boolean;
  walletIcon?: string;
  walletId?: string;
  connect: (params: ConnectArgs) => void;
  disconnect: () => void;
  features: { isAddTokenAvailable: boolean };
  switchNetwork: (chainId: number) => void;
  isSwitchNetworkLoading: boolean;
}

export function useConnection(): IConnectionData {
  const [switchNetwork, { isLoading: isSwitchNetworkLoading }] =
    useSwitchNetworkMutation();

  const [connect, { data, isLoading }] = useConnectMutation({
    fixedCacheKey: CONNECTION_CACHE_KEY,
  });

  const [disconnect] = useDisconnectMutation({
    fixedCacheKey: CONNECTION_CACHE_KEY,
  });

  const {
    address,
    chainId,
    isActive: isConnected = false,
    walletId,
  } = data ?? {};

  const handleDisconnect = useCallback(() => {
    const result = disconnect();
    result.reset();
  }, [disconnect]);

  const connectCallback = async (
    connectArgs: Parameters<typeof connect>[0],
  ) => {
    try {
      await connect(connectArgs);
    } catch (error) {
      console.error(error);
    }
  };

  return {
    address,
    chainId,
    isConnected,
    isLoading,
    walletId,
    connect: connectCallback,
    disconnect: handleDisconnect,
    switchNetwork,
    isSwitchNetworkLoading,
    features: {
      isAddTokenAvailable:
        walletId !== EWalletId.walletconnect &&
        walletId !== EWalletId.binanceWallet,
    },
  };
}
